import { getMappingVariables } from './get-mapping-variables';
import { variablePattern } from './types';
export var lowerCaseMapping = function (mapping) {
    if (typeof mapping !== 'string') {
        return mapping;
    }
    var variables = getMappingVariables(mapping);
    return mapping
        .split(new RegExp(variablePattern, 'g'))
        .map(function (segment) {
        return variables.includes(segment) ? "{{" + segment + "}}" : segment.toLowerCase();
    })
        .join('');
};
//# sourceMappingURL=lower-case-mappings.js.map